<template>
    <wizard-panel name="qualifications" :status="panels.qualifications">
        <div class="wizard-panel__inner" v-if="panels.qualifications === 1">
            <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
                <header class="panel-head">
                    <div class="badge wizard-panel__badge" v-html="kindName"></div>

                    <div class="panel-head__inner">
                        <div class="panel-head__item">
                            <h2>Квалификации</h2>
                        </div>
                    </div>
                </header>

                <div class="wizard-panel__content">
                    <el-table
                        cell-class-name="table__cell table__cell_choose"
                        class="table table_second table_in-panel"
                        header-cell-class-name="table__title"
                        max-height="400"
                        :data="qualificationsByKind"
                        @current-change="openQualification"
                    >
                        <el-table-column
                            label="Название ПК"
                            prop="name"
                            sortable
                            :min-width="150"
                        />
                    </el-table>
                </div>
            </div>
        </div>
        <div class="wizard-panel__inner" v-else-if="panels.qualifications === 2 && activeQualification">
            <div class="wizard-panel__column js-wizard-panel-column pb-0">
                <div class="badge wizard-panel__badge" v-html="kindName"></div>

                <h2>Проекты квалификации</h2>

                <div class="wizard-panel__content">
                    <el-table
                        cell-class-name="table__cell table__cell_choose"
                        class="table table_second table_in-panel table_transparent"
                        header-cell-class-name="table__title"
                        max-height="400"
                        :data="qualificationsByKind"
                        @current-change="openQualification"
                    >
                        <el-table-column
                            label="Название ПК"
                            prop="name"
                            sortable
                            :min-width="150"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </wizard-panel>
</template>

<script>
import Vue from 'vue';
// import MaskedInput from 'vue-masked-input';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import panel from '@/mixins/panel';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import LocalPreloader from '@/components/LocalPreloader';
import QualificationPanel from "@/components/WizardPanels/QualificationPanel.vue";

export default {
    mixins: [ panel ],
    props: {
        kindId: {
            required: true,
            type: Number
        }
    },
    components: {
        Accordion,
        AccordionItem,
        WizardPanel,
        LocalPreloader,
        QualificationPanel
    },
    data() {
        return {
            activeQualification: null,
            workFunctionsByQualificationLoader: false,
            programsByQualificationLoader: false,
            standartLoader: false,
        }
    },
    methods: {
        ...mapActions('editor', ['LOAD_QUALIFICATION', 'SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION', 'SILENT_LOAD_PROGRAMS_BY_QUALIFICATION', 'SILENT_LOAD_STANDARD']),
        async openQualification(currentRow) {
            await this.LOAD_QUALIFICATION(currentRow.id);


            this.elPanels.qualification = 1;
            this.elPanels.qualifications = 0;

            this.activeQualification = this.qualification

            this.standartLoader = true
            this.workFunctionsByQualificationLoader = true
            this.programsByQualificationLoader = true

            if (this.qualification.standard_id) {
              await this.loadStandart(this.qualification.standard_id);
            }
            this.standartLoader = false;
            await this.loadWorkFunctionsByQualification(currentRow.id);
            await this.loadWorkProgramsByQualificationLoader(this.qualification.id);;
        },
        async loadWorkFunctionsByQualification(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(id),
            this.workFunctionsByQualificationLoader = false
        },
        async loadWorkProgramsByQualificationLoader(id) {
            await this.SILENT_LOAD_PROGRAMS_BY_QUALIFICATION(id),
            this.programsByQualificationLoader = false
        },
        async loadStandart(id) {
            await this.SILENT_LOAD_STANDARD(id),
            this.standartLoader = false
        },
    },
    computed: {
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_KIND_BY_ID']),
        ...mapState('common', ['panels']),
        ...mapState('editor', ['standard', 'programsByQualification', 'qualificationsByKind', 'qualification', 'workFunctionsByQualification']),
        kindName() {
            if (this.kindId === 0) {
              return 'Квалификации, не привязанные к профстандарту'
            }
            return this.GET_KIND_BY_ID(this.kindId).name;
        },
        areaName() {
          if (this.kindId === 0) {
            return  '–';
          }
          return this.GET_AREA_BY_ID(this.GET_KIND_BY_ID(this.activeQualification.kind_id).area_id).name
        },
    }
}
</script>
